import { render, staticRenderFns } from "./SubjectEditDialog.vue?vue&type=template&id=5031b758"
import script from "./SubjectEditDialog.vue?vue&type=script&lang=js"
export * from "./SubjectEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports